import React from 'react';

import { FatalAttraction as FA } from '@vpr/tracking';

import { Button } from '@vimeo/iris/components';
import { themes } from '@vimeo/iris/themes';

import { NoWrapHeader, PageControlHeader } from './Styles';
import * as translations from '../../../translations';
import { AlbumThemes } from '../../types';

interface Props {
  theme: AlbumThemes;
  currentPage?: number;
  pageSize?: number;
  totalItems: number;
  onShare: VoidFunction;
  allowShare: boolean;
}

function PaginationHeader({
  theme = 'standard',
  currentPage = 1,
  pageSize = 12,
  totalItems,
  onShare,
  allowShare,
}: Props) {
  const startIdx = (currentPage - 1) * pageSize;
  const endIdx = Math.min(currentPage * pageSize, totalItems);
  const lastPage = Math.ceil(totalItems / pageSize);

  return (
    <PageControlHeader>
      {lastPage > 1 && (
        <NoWrapHeader>
          <span>
            {startIdx + 1} - {endIdx} of {totalItems}
          </span>
        </NoWrapHeader>
      )}
      {allowShare && (
        <Button
          format={theme === 'standard' ? 'alternative' : 'secondary'}
          theme={theme === 'standard' ? themes.light : themes.dark}
          size="md"
          onClick={() => {
            onShare();
            FA.trackClick({
              container: 'showcase',
              component: 'share',
            });
          }}
        >
          {translations.share}
        </Button>
      )}
    </PageControlHeader>
  );
}

export default PaginationHeader;
